import styled from 'styled-components';
import { StyledDeviceStoreAvailabilityProps } from './DeviceStoreAvailability.types';

export const StyledDeviceStoreAvailability = styled.div<StyledDeviceStoreAvailabilityProps>`
  .device-store-availability__slot-li {
    list-style: none;
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
